module.exports = __webpack_public_path__ + "img/article-deleted.7f66de63.png";